import { Textarea } from '@tempo-io/sui-textarea';
import { type ReactNode, useEffect, useState } from 'react';
import { EmptyFieldValue } from '@/components/common/item-field-value/EmptyFieldValue';
import { FieldWithStatusIndicator } from '@/components/common/item-field-value/FieldWithStatusIndicator';

export const MultilineTextField = ({
  id,
  name,
  value,
  isEditable = false,
  onChange,
  isPending,
  isSuccess,
  isError,
  error,
  autoFocus = false,
  action,
}: {
  id: string;
  name: string;
  value?: string;
  isEditable?: boolean;
  onChange?: (value: string) => void;
  isPending?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  error?: Error | null;
  autoFocus?: boolean;
  action?: ReactNode;
}) => {
  const inputId = `multiline-text-field-${id}`;
  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setLocalValue(e.target.value);
  };

  const handleBlur = () => {
    if (localValue !== value) {
      onChange?.(localValue);
    }
  };

  return (
    <FieldWithStatusIndicator
      inputId={inputId}
      name={name}
      isPending={isPending}
      isSuccess={isSuccess}
      action={action}
    >
      {isEditable ? (
        <div className="flex flex-col gap-1">
          <Textarea
            className="h-40"
            id={inputId}
            value={localValue}
            onChange={handleChange}
            onBlur={handleBlur}
            autoFocus={autoFocus}
            disabled={isPending}
          />
          {isError && error && <span className="text-xs text-text-error">{error.message}</span>}
        </div>
      ) : (
        <div className="text-sm text-text-neutral-primary whitespace-pre-wrap">
          {value || <EmptyFieldValue />}
        </div>
      )}
    </FieldWithStatusIndicator>
  );
};
